export const DEFAULT_LANGUAGE: DefaultLanguage = 'fr';
